<template>
  <div class="main" @click.self="$emit('close')">
    <div class="box-modal">
      <span class="title" >هشدار
      !
      </span>

      <div class=""><p>آیا از لغو سفارش خود اطمینان دارید؟</p></div>

<!--      <div class="order">-->
<!--        <div class="data-list">-->
<!--          <span>مقدار</span>-->
<!--          <span>{{0}}</span>-->
<!--        </div>-->
<!--        <div class="data-list">-->

<!--          <span>کارمزد</span>-->
<!--          <span>{{0}}</span>-->
<!--        </div>-->
<!--        <div class="data-list">-->
<!--          <span>دریافتی</span>-->
<!--          <span>{{0}}</span>-->
<!--        </div>-->

<!--      </div>-->


      <button @click.self="$emit('remove')" class="blue-btn">تایید</button>
    </div>
  </div>
</template>

<script>

export default {
  name: "buyModal",
  // props: {
  //   data: {
  //     type: Object,
  //   },
  // },
  // required: true
  // components: {CustomInput}
}
</script>

<style lang="scss" scoped>
.order{
  display: flex;
  flex-direction: column;
  gap: 4px;
  .data-list{
    display: flex;
    justify-content: space-between;
  }
}
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0, 0.7);
  z-index: 10;

  .box-modal {
    background-color: rgba(11, 20, 38, 1);
    display: flex;
    min-width: 250px;
    flex-direction: column;
    color: #FFFFFF;
    border-radius: 16px;
    padding: 16px;
    gap: 20px;

    .title {
      font-size: clamp(14px, 2vw, 16px);
      color: red;
      font-weight: bold;
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 28px;
    }

  }
}
</style>